/**
 * Spacing constants shared across SPDS components.
 */

// Gap between the action buttons in a modal or panel header
export const ACTIONS_GAP_DEFAULT = '11px';
